import styled, {createGlobalStyle, css} from 'styled-components'

export const Label = styled.div`
  color: ${({theme}) => theme.grey50};
  pointer-events: none;
`

export const AddVariableWrapper = styled.div`
  width: 60px;
  height: 60px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex: none;
  opacity: 0;
`
// NOTE these dimensions need to match the hardcoded extra top padding on the
// .editable element
export const Wrapper = styled.div`
  position: relative;
  display: flex;
  font-size: ${({theme}) => theme.fontSize};
  &:hover ${AddVariableWrapper}, &:focus-within ${AddVariableWrapper} {
    opacity: 1;
  }
  ${Label} {
    top: 20px;
    position: absolute;
    line-height: ${({theme}) => theme.lineHeightCompact};
    font-size: ${({theme}) => theme.fontSize};
    transition:
      0.1s top,
      0.1s font-size;
  }

  &.labelUp {
    ${Label} {
      top: 10px;
      font-size: ${({theme}) => theme.fontSizeS};
    }
  }
`

export const StyledTextEditor = styled.div<{readOnly?: boolean}>`
  flex: 1;
  margin-left: -10px;
  .editable {
    flex: 1;
    /* add a small click area to the left, so the cursor can be placed at the
       start */
    padding-left: 10px;
    /* leave space for the label - see Wrapper */
    padding-top: 30px;
    padding-bottom: 10px;
    min-height: 60px;
    min-width: 100%;
    &.single {
      white-space: nowrap;
      width: 200px;
      overflow: hidden;
      br {
        display: none;
      }
      * {
        display: inline;
        white-space: nowrap;
      }
    }
    .variable {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: ${({theme}) => theme.fontSizeXS};
      line-height: ${({theme}) => theme.lineHeightCompact};
      border-radius: ${({theme}) => theme.borderRadiusPill};
      padding: 0 8px;
      height: 20px;
      user-select: none;
      margin: -1px 0;
      cursor: pointer;
      ${({readOnly, theme}) =>
        readOnly
          ? css`
              background: ${theme.grey05};
            `
          : css`
              color: ${theme.blue};
              background: ${theme.blueLightest};
              &:hover,
              &:focus {
                background: ${theme.blueLight};
              }
              &:active {
                background: ${theme.blueLightest};
              }
              &.invalid {
                color: ${theme.red};
                background: ${theme.redLightest};
                &:hover,
                &:focus {
                  background: ${theme.redLight};
                }
                &:active {
                  background: ${theme.redLightest};
                }
              }
            `}
    }
  }
`

export const IconWrap = styled.div``
export const EditorWrap = styled.div``

export const TextEditorWrapper = styled.div<{readOnly?: boolean}>`
  border-radius: 5px;
  padding-left: 20px;
  display: flex;

  > ${IconWrap} {
    height: 60px;
    width: 60px;
    margin-left: -20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  > ${EditorWrap} {
    flex: 1;
  }

  ${({readOnly, theme}) =>
    readOnly
      ? css`
          background: ${theme.white};
          border: solid 1px ${theme.grey20};
        `
      : css`
          background: ${p => p.theme.grey05};
          &:hover,
          &:focus-within {
            background: ${theme.grey10};
          }
          &:active {
            background: ${theme.grey15};
          }
        `}
`

// insert tribute styles globally, since it's not rendered by react
export const TributeStyle = createGlobalStyle`
.tribute-container {
  position: absolute;
  padding: 10px 0;
  background: white;
  top: 0;
  left: 0;
  border-radius: 5px;
  height: auto;
  max-height: 300px;
  width: 200px;
  overflow: auto;
  display: block;
  z-index: 999999;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    background: white;
    li {
      padding: 10px 20px;
      line-height: 20px;
      cursor: pointer;
      &.highlight {
        background: rgba(0,0,0,0.05);
      }
      &.no-match {
        cursor: default;
      }
    }
  }
  .menu-highlighted {
    font-weight: bold;
  }
}
`
